import { ItemView, locale, util } from '@glu/core';

import template from './pageSizeControls.hbs';


export default ItemView.extend({
  template,

  ui: {
    $sizeSelect: '.paginate-page-size'
  },

  events: {
    'change @ui.$sizeSelect': 'handleSizeSelect'
  },

  templateHelpers() {
    return {
      cid: this.cid
    };
  },

  handleSizeSelect(e) {
    const vals = this.$(e.currentTarget).flexDropdown('val');
    this.options.pager.updatePageSizeValue(vals[0]);
  },

  onBeforeClose() {
    this.ui.$sizeSelect.flexDropdown('destroy');
  },
  onRender() {
    this.initDropDown();
  },

  initDropDown() {
    const { pager } = this.options;

    this.ui.$sizeSelect.flexDropdown({
      label: locale.get('display'),
      showTooltip: false,
      disableMultiButton: true,
      preSelectedIds: [this.options.data.pageSize],
      data: util.map(this.options.data.pageSizeList, (pageSize) => ({
        id: pageSize,
        name: pageSize
      })),
      dataQA: `${pager.options.id}-per-page`
    });
  }
});
